export enum UICollectionTypes {
  ExistingProducer = 'ExistingProducer',
  PhotovoltaicModule = 'PhotovoltaicModule',
  PowerInverter = 'PowerInverter',
  Generator = 'Generator',
  StorageUnit = 'StorageUnit',
  PowerConverter = 'PowerConverter',
}

export enum EnergyType {
  Photovoltaics = 0,
  Storage = 1,
  Bhkw = 2,
  WindPowerPlant = 3,
  HydroPowerPlant = 4,
  FuelCell = 5,
  Other = 6,
}

export enum EnergySource {
  Solar = 0,
  Wind = 1,
  Water = 2,
  Biomass = 3,
  NaturalGas = 4,
  Other = 5,
}

export enum TechnicalSpecificationsFormSections {
  BaseData = 0,
  ExistingEnergyProducer = 1,
  DetailedInfoPhotovoltaics = 2,
  DetailedInfoEnergyProducer = 3,
  DetailedInfoStorage = 4,
  DetailedInfoGridPowerPlant = 5,
  TypeOfFeedIn = 6,
  FeedInControllability = 7,
  ConceptOfMeasurement = 8,
  MeterOperation = 9,
}

export enum PersonalDataFormSections {
  ConnectionAddress = 0,
  SubscriberOwner = 1,
  InvoiceAddress = 2,
  OperatorOfPowerPlant = 3,
}

export enum DocumentFormSections {
  Documents = 0,
}
